import { render, staticRenderFns } from "./InfoGoodsReview.vue?vue&type=template&id=9003c1fa&scoped=true&"
import script from "./InfoGoodsReview.vue?vue&type=script&lang=js&"
export * from "./InfoGoodsReview.vue?vue&type=script&lang=js&"
import style0 from "./InfoGoodsReview.vue?vue&type=style&index=0&id=9003c1fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9003c1fa",
  null
  
)

export default component.exports